module.exports = __webpack_public_path__ + "static/media/icon_17.0031d0ce.svg";